<template>
    <div>
        <b-card class="main-area" no-body>
            <b-tabs class="main-area" pills card vertical>
                <b-tab title="Editar dados" active>
                    <edit-profile :id="null"></edit-profile>
                </b-tab>
                <b-tab title="Editar senha">
                    <edit-password :id="null"></edit-password>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import EditProfile from './../../components/EditProfile';
import EditPassword from './../../components/EditPassword';

export default {
    name: "Profile",
    components: {
        EditProfile,
        EditPassword
    }
}
</script>

<style>

.main-area {
    background-color: #ddcecb;
}

</style>